import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'

export const OrgContextsTable = ({ organization }) => {
  return (
    <Fragment>
      <Table striped bordered className="table-sm" hover>
        <thead>
          <tr>
            <th>Context ID</th>
            <th>Context Title</th>
            <th>Created</th>
            <th>Course Count</th>
            <th>Manage Context</th>
          </tr>
        </thead>
        <tbody>
          {organization &&
            organization.contexts.map((context, i) => (
              <tr key={i}>
                <td>{context.contextId}</td>
                <td>{context.contextTitle}</td>
                <td>{context.createDate}</td>
                <td>{context.connectedCourses.length}</td>
                <td>
                  <Link
                    to={`/account/admin_lti_org_key_management/-/organizations/${organization.id}/contexts/${context.id}`}
                  >
                    View Context
                  </Link>
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </Fragment>
  )
}
